<template>
    <div class="relative z-40 md:hidden">
        <transition
            enter-active-class="transition-opacity ease-linear duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-if="isOpen"
                id="mobile-menu"
                ref="dialogRef"
                role="dialog"
                aria-modal="true"
                aria-label="Main menu"
                tabindex="-1"
                class="fixed inset-0 z-40"
                @keydown.escape="$emit('close')"
            >
                <nav
                    class="fixed inset-0 z-40 h-full w-full bg-white sm:inset-y-0 sm:left-auto sm:right-0 sm:w-full sm:max-w-sm sm:shadow-lg"
                    aria-label="Global"
                >
                    <div
                        class="flex h-16 items-center justify-between px-4 sm:px-6"
                    >
                        <router-link
                            :to="{
                                name: 'ProjectFlagsScreen',
                                params: current,
                            }"
                            class="rounded-md focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-sky-600"
                            aria-label="Zenmanage home"
                        >
                            <svg
                                class="block h-8 w-auto"
                                aria-hidden="true"
                                width="57.811763763427734"
                                height="57.826480865478516"
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                xmlns:svgjs="http://svgjs.com/svgjs"
                                viewBox="0 0 57.811763763427734 57.826480865478516"
                            >
                                <defs></defs>
                                <rect
                                    width="57.811763763427734"
                                    height="57.826480865478516"
                                    fill="transparent"
                                ></rect>
                                <g
                                    transform="matrix(1,0,0,1,-55.88774490356445,-53.58749008178711)"
                                >
                                    <path
                                        d="M103.354,63.931h0c-1.904-1.904-4.437-2.953-7.13-2.953s-5.226,1.049-7.13,2.953c-1.905,1.905-2.954,4.437-2.954,7.13s1.049,5.226,2.954,7.13c1.904,1.904,4.437,2.953,7.13,2.953s5.225-1.049,7.13-2.953c1.905-1.904,2.954-4.437,2.954-7.13s-1.049-5.226-2.953-7.13Zm-3.271,10.99c-1.031,1.031-2.401,1.598-3.859,1.598s-2.829-.568-3.86-1.598c-1.031-1.031-1.599-2.402-1.599-3.859s.568-2.829,1.599-3.859,2.402-1.599,3.86-1.599,2.828,.568,3.859,1.598h0c1.031,1.031,1.598,2.402,1.598,3.86s-.568,2.828-1.599,3.859Zm-.959-3.859c0,1.601-1.298,2.9-2.9,2.9s-2.9-1.299-2.9-2.9,1.298-2.9,2.9-2.9,2.9,1.299,2.9,2.9Zm3.357,29.203c-.166,.166-.321,.34-.465,.519-1.422-1.42-2.312-3.372-2.312-5.535,0-1.711,.559-3.357,1.568-4.703l7.347-7.347c6.774-6.774,6.774-17.757,0-24.531h0c-6.774-6.774-17.757-6.774-24.531,0l-7.443,7.443c-1.325,.957-2.927,1.489-4.59,1.489-2.164,0-4.116-.89-5.536-2.312,.179-.145,.353-.299,.52-.466,2.547-2.547,2.547-6.69,0-9.236s-6.69-2.546-9.236,0c-2.547,2.547-2.547,6.69,0,9.236,1.094,1.094,2.484,1.715,3.916,1.869,2.239,3.331,6.029,5.534,10.336,5.534,2.677,0,5.254-.863,7.376-2.419-.031,.415-.052,.833-.052,1.257,0,.929,.078,1.84,.223,2.728l-5.104,5.103c-.04,.036-.085,.064-.124,.103-1.634,1.657-3.532,2.643-5.458,2.949-.132-1.472-.758-2.908-1.882-4.032-2.546-2.546-6.689-2.547-9.236,0-2.547,2.547-2.547,6.69,0,9.236,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c.151-.151,.292-.309,.425-.47,.058,0,.116,.006,.174,.006,3.483,0,6.987-1.456,9.842-4.264,.064-.052,.132-.097,.192-.157l3.551-3.551c.454,.888,.982,1.732,1.58,2.52l-17.678,17.677c-2.403-1.078-5.326-.64-7.296,1.331-2.547,2.547-2.547,6.69,0,9.236,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c1.97-1.97,2.409-4.893,1.331-7.296l17.68-17.68c.789,.597,1.634,1.124,2.523,1.576l-3.557,3.557c-.054,.054-.094,.116-.141,.173-2.863,2.903-4.306,6.481-4.26,10.023-.167,.136-.328,.282-.484,.437-2.547,2.547-2.547,6.69,0,9.236,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c2.547-2.547,2.547-6.69,0-9.236-1.124-1.124-2.559-1.75-4.031-1.882,.307-1.926,1.292-3.825,2.949-5.458,.039-.038,.066-.083,.102-.123l5.116-5.117c.879,.142,1.78,.218,2.699,.218,.426,0,.847-.021,1.265-.052l.013,.012c-1.559,2.122-2.423,4.702-2.423,7.381,0,4.307,2.203,8.097,5.534,10.336,.153,1.431,.774,2.821,1.869,3.916,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c2.547-2.547,2.547-6.69,0-9.236-2.546-2.546-6.689-2.547-9.236,0ZM61.073,58.856c.372-.372,.859-.557,1.348-.557s.976,.186,1.347,.557c.743,.743,.743,1.951,0,2.695-.743,.743-1.952,.743-2.695,0-.743-.743-.743-1.952,0-2.695Zm2.691,25.023c-.743,.743-1.951,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.347-.557s.976,.186,1.348,.557c.743,.743,.743,1.952,0,2.695Zm.026,22.328c-.743,.743-1.951,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.347-.557s.976,.186,1.348,.557c.743,.743,.743,1.951,0,2.695Zm22.328,.026c-.743,.743-1.952,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.348-.557s.976,.186,1.347,.557c.743,.743,.743,1.951,0,2.695Zm1.153-26.22c-4.944-4.944-4.944-12.961,0-17.905,4.944-4.944,12.961-4.944,17.905,0,4.944,4.944,4.944,12.961,0,17.905-4.944,4.944-12.961,4.944-17.905,0Zm21.175,26.216c-.743,.742-1.951,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.347-.557s.976,.186,1.348,.557c.743,.743,.743,1.951,0,2.695Z"
                                        fill="#000000"
                                    ></path>
                                </g>
                            </svg>
                        </router-link>
                        <button
                            type="button"
                            @click="$emit('close')"
                            class="cursor-pointer -mr-2 inline-flex items-center justify-center rounded-md p-2 text-taupe-500 hover:bg-taupe-50 hover:text-taupe-500 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-sky-600"
                        >
                            <span class="sr-only">Close main menu</span>
                            <zen-icon-close />
                        </button>
                    </div>

                    <!-- Environment picker -->
                    <div class="px-4 py-3 border-b border-taupe-100">
                        <environment-picker
                            :active="showSidebar"
                            @changed="onEnvironmentChanged"
                        />
                    </div>

                    <!-- Navigation links -->
                    <div class="px-3 py-3 space-y-0.5">
                        <p
                            class="px-3 pb-1 text-xs font-medium uppercase tracking-wider text-taupe-400"
                        >
                            Navigation
                        </p>
                        <router-link
                            @click="$emit('close')"
                            :to="{
                                name: 'ProjectFlagsScreen',
                                params: current,
                            }"
                            class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-taupe-700 hover:bg-taupe-100"
                        >
                            Flags
                        </router-link>
                        <router-link
                            @click="$emit('close')"
                            :to="{
                                name: 'ProjectContextsScreen',
                                params: current,
                            }"
                            class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-taupe-700 hover:bg-taupe-100"
                        >
                            Contexts
                        </router-link>
                        <router-link
                            @click="$emit('close')"
                            :to="{
                                name: 'ProjectDebugConsoleScreen',
                                params: current,
                            }"
                            class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-taupe-700 hover:bg-taupe-100"
                        >
                            Debug Console
                        </router-link>
                        <router-link
                            @click="$emit('close')"
                            :to="{
                                name: 'ProjectReportsScreen',
                                params: current,
                            }"
                            class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-taupe-700 hover:bg-taupe-100"
                        >
                            Reports
                        </router-link>
                    </div>

                    <!-- Admin -->
                    <div
                        v-if="showAdmin"
                        class="px-3 py-3 border-t border-taupe-100 space-y-0.5"
                    >
                        <p
                            class="px-3 pb-1 text-xs font-medium uppercase tracking-wider text-taupe-400"
                        >
                            Admin
                        </p>
                        <router-link
                            @click="$emit('close')"
                            :to="{ name: 'AdminProjectsScreen' }"
                            class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-red-500 hover:bg-red-50"
                        >
                            Admin Settings
                        </router-link>
                    </div>

                    <!-- Trial actions -->
                    <div
                        v-if="isTrial && isAdminUser"
                        class="px-3 py-3 border-t border-taupe-100 space-y-0.5"
                    >
                        <p
                            class="px-3 pb-1 text-xs font-medium uppercase tracking-wider text-taupe-400"
                        >
                            Trial
                        </p>
                        <button
                            v-if="
                                onboardingStore.total > 0 &&
                                onboardingStore.percentComplete < 100
                            "
                            type="button"
                            class="cursor-pointer flex items-center justify-between w-full rounded-lg py-2.5 px-3 text-sm font-medium text-sky-700 hover:bg-sky-50"
                            @click="openGettingStarted"
                        >
                            <span>Getting Started</span>
                            <span
                                class="text-xs font-medium bg-sky-100 text-sky-600 rounded-full px-2 py-0.5"
                                >{{ onboardingStore.completedCount }}/{{
                                    onboardingStore.total
                                }}</span
                            >
                        </button>
                        <router-link
                            v-if="canManageBilling"
                            @click="$emit('close')"
                            :to="{ name: 'AdminBillingScreen' }"
                            class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-sky-700 hover:bg-sky-50"
                        >
                            Upgrade Plan
                        </router-link>
                    </div>

                    <!-- User section -->
                    <div class="border-t border-taupe-100 px-4 py-4 mt-auto">
                        <div class="flex items-center gap-3 mb-3">
                            <img
                                class="h-9 w-9 rounded-full shrink-0"
                                :src="avatar"
                                alt=""
                            />
                            <div class="min-w-0">
                                <p
                                    class="truncate text-sm font-medium text-taupe-800"
                                >
                                    {{
                                        (user?.first_name ?? '') +
                                        ' ' +
                                        (user?.last_name ?? '')
                                    }}
                                </p>
                                <p class="truncate text-xs text-taupe-500">
                                    {{ user?.email }}
                                </p>
                            </div>
                        </div>
                        <div class="space-y-0.5">
                            <router-link
                                @click="$emit('close')"
                                :to="{ name: 'ProfileDefaultScreen' }"
                                class="flex items-center rounded-lg py-2.5 px-3 text-sm font-medium text-taupe-700 hover:bg-taupe-100"
                            >
                                Your Profile
                            </router-link>
                            <button
                                @click="onSignout"
                                class="cursor-pointer flex items-center w-full rounded-lg py-2.5 px-3 text-sm font-medium text-red-500 hover:bg-red-50"
                            >
                                Sign Out
                            </button>
                        </div>
                    </div>
                </nav>
            </div>
        </transition>
    </div>
</template>

<script>
import { ref } from 'vue'
import { useFocusTrap } from '@/composables/useFocusTrap'
import EnvironmentPicker from '@/screens/_components/EnvironmentPicker/EnvironmentPicker.vue'

export default {
    name: 'MobileNavMenu',
    components: { EnvironmentPicker },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        current: {
            type: Object,
            required: true,
        },
        showSidebar: {
            type: Boolean,
            default: false,
        },
        showAdmin: {
            type: Boolean,
            default: false,
        },
        isTrial: {
            type: Boolean,
            default: false,
        },
        isAdminUser: {
            type: Boolean,
            default: false,
        },
        canManageBilling: {
            type: Boolean,
            default: false,
        },
        onboardingStore: {
            type: Object,
            required: true,
        },
        avatar: {
            type: String,
            default: '',
        },
        user: {
            type: Object,
            default: null,
        },
        environmentChanged: {
            type: Function,
            required: true,
        },
        signout: {
            type: Function,
            required: true,
        },
    },
    emits: ['close'],
    setup(props) {
        const dialogRef = ref(null)
        useFocusTrap(dialogRef, () => props.isOpen)
        return { dialogRef }
    },
    methods: {
        async onEnvironmentChanged() {
            await this.environmentChanged()
        },
        openGettingStarted() {
            this.onboardingStore.open()
            window.dispatchEvent(
                new CustomEvent('zenmanage:open-getting-started')
            )
            this.$emit('close')
        },
        async onSignout() {
            await this.signout()
        },
    },
}
</script>
